module.exports = __webpack_public_path__ + "static/joven_exitoso-b32348a0b88a0d406a0683582e95dd71.jpeg";